import { render, staticRenderFns } from "./create_business_account4.vue?vue&type=template&id=66cf7ebe&scoped=true"
import script from "./create_business_account4.vue?vue&type=script&lang=js"
export * from "./create_business_account4.vue?vue&type=script&lang=js"
import style0 from "./create_business_account4.vue?vue&type=style&index=0&id=66cf7ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf7ebe",
  null
  
)

export default component.exports